import { render, staticRenderFns } from "./PlayerAverages.vue?vue&type=template&id=1de5cb7a&scoped=true&"
import script from "./PlayerAverages.vue?vue&type=script&lang=js&"
export * from "./PlayerAverages.vue?vue&type=script&lang=js&"
import style0 from "./PlayerAverages.vue?vue&type=style&index=0&id=1de5cb7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de5cb7a",
  null
  
)

export default component.exports